import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('bf_privacy_accepted');
    if (!accepted) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('bf_privacy_accepted', 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: '#2b436e',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        padding: '16px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '12px',
        boxShadow: '0 -4px 20px rgba(0,0,0,0.3)',
      }}
    >
      <p
        style={{
          margin: 0,
          color: '#e8edf5',
          fontSize: '14px',
          lineHeight: '1.6',
          flex: '1 1 300px',
        }}
      >
        By continuing to use this website, you agree to our{' '}
        <Link
          to="/privacy-policy"
          style={{ color: '#93c5fd', textDecoration: 'underline', fontWeight: '500' }}
        >
          Privacy Policy
        </Link>
        {' '}and{' '}
        <Link
          to="/terms-and-conditions"
          style={{ color: '#93c5fd', textDecoration: 'underline', fontWeight: '500' }}
        >
          Terms &amp; Conditions
        </Link>
        . We use cookies to improve your experience on our site.
      </p>

      <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexShrink: 0 }}>
        <button
          onClick={handleAccept}
          style={{
            backgroundColor: '#4e73df',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            padding: '10px 24px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            transition: 'background-color 0.2s ease',
          }}
          onMouseEnter={e => (e.target.style.backgroundColor = '#375bd2')}
          onMouseLeave={e => (e.target.style.backgroundColor = '#4e73df')}
        >
          Got it
        </button>
        <button
          onClick={handleAccept}
          aria-label="Dismiss"
          style={{
            background: 'none',
            border: 'none',
            color: '#c5d3e8',
            fontSize: '20px',
            cursor: 'pointer',
            lineHeight: 1,
            padding: '4px 8px',
          }}
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
